export const sentToCandidateListItems = {
  INDIVIDUAL_BROKER: [
    "Authorize a background and credit check",
    "Provide personal information which may include your demographic, contact, residential address, business address, and Broker Dealer registration status",
    "Provide character, credit, and bonding information",
    "Provide your errors and omissions coverage status",
    "Provide your banking information to set up direct deposit",
  ],
  CAREER_AGENT: [
    "Authorize a background and credit check",
    "Provide personal information which may include your contact and business address as well as 5 years of residential history",
    [
      "Provide 10 years of employment history as well as your personal sales record (PSR)",
      [
        "Gather your commissions statements before starting this area",
        "Your last 5 years plus the current year of commissions for selling Individual Life, Annuity, Disability and Long Term Care are needed for the PPR",
      ],
    ],
    [
      "Provide information related to any legal, criminal and regulatory proceedings",
      ["Court records may need to be submitted"],
    ],
    "Provide your banking information to set up direct deposit",
  ],
  CAREER_SAMPLING: [
    "Authorize a background and credit check",
    "Provide personal information which may include your contact and business address as well as 5 years of residential history",
    [
      "Provide 10 years of employment history as well as your personal sales record (PSR)",
      [
        "Gather your commissions statements before starting this area",
        "Your last 5 years plus the current year of commissions for selling Individual Life, Annuity, Disability and Long Term Care are needed for the PSR",
      ],
    ],
    [
      "Provide information related to any legal, criminal and regulatory proceedings",
      ["Court records may need to be submitted"],
    ],
    "Provide your banking information to set up direct deposit",
  ],
  ALTERNATE_AGENT: [
    "Authorize a background and credit check",
    "Provide personal information which may include your contact and business address as well as 5 years of residential history",
    [
      "Provide 10 years of employment history as well as your personal sales record (PSR)",
      [
        "Gather your commissions statements before starting this area",
        "Your last 5 years plus the current year of commissions for selling Individual Life, Annuity, Disability and Long Term Care are needed for the PSR",
      ],
    ],
    [
      "Provide information related to any legal, criminal and regulatory proceedings",
      ["Court records may need to be submitted"],
    ],
    "Provide your banking information to set up direct deposit",
  ],
  COLLEGE_INTERN: [
    "Authorize a background and credit check",
    "Provide personal information which may include your contact and 5 years of residential history",
    [
      "Provide 10 years of employment history as well as your personal sales record (PSR)",
      [
        "Gather your commissions statements before starting this area",
        "Your last 5 years plus the current year of commissions for selling Individual Life, Annuity, Disability and Long Term Care are needed for the PSR",
      ],
    ],
    [
      "Provide information related to any legal, criminal and regulatory proceedings",
      ["Court records may need to be submitted"],
    ],
    "Provide your banking information to set up direct deposit",
  ],
  BROKER_CORP: [
    "Authorize a background and credit check",
    "Provide personal information which may include your contact, residential address, and Broker Dealer registration status",
    "Provide character, credit, and bonding information",
    "Provide your errors and omissions coverage status",
    "Provide your banking information to set up direct deposit",
  ],
  MEMBER_CORP: [
    "Authorize a background and credit check",
    "Provide personal information which may include your contact, residential address, and Broker Dealer registration status",
    "Provide character, credit, and bonding information",
    "Provide your errors and omissions coverage status",
  ],
  MMLIS: [
    "Authorize a background and credit check",
    "Provide personal information which may include your contact and business address as well as 5 years of residential history",
    "Provide 10 years of employment history",
    [
      "Provide information related to any legal, criminal and regulatory proceedings",
      ["Court records may need to be submitted"],
    ],
  ],
  FINANCING_ONLY: ["Provide personal information"],
  PRELIMINARY: [
    "Authorize a background and credit check",
    "Provide personal information which may include your contact and business address as well as 5 years of residential history",
    [
      "Provide 10 years of employment history as well as your personal sales record (PSR)",
      [
        "Gather your commissions statements before starting this area",
        "Your last 5 years plus the current year of commissions for selling Individual Life, Annuity, Disability and Long Term Care are needed for the PSR",
      ],
    ],
    [
      "Provide information related to any legal, criminal and regulatory proceedings",
      ["Court records may need to be submitted"],
    ],
  ],
  AGENT_EMERITUS: [
    "Provide personal information which may include your contact and business address",
    "Provide your banking information to set up direct deposit",
  ],
  RETIRED_BROKER: [
    "Provide personal information which may include your contact and business address",
    "Provide your banking information to set up direct deposit",
  ],
  CRIA_ONLY: [
    "Provide personal information which may include your contact information and MassMutual Identification number",
    "Provide your Education History",
    "Provide Professional Registrations or Designations",
  ],
};
